import { create } from "zustand";

import type { SocialProvider } from "@/features/auth/api";

type AuthUiState = {
  passwordSaved: boolean;
  setPasswordSaved: (saved: boolean) => void;
  pendingSocialProvider: SocialProvider | null;
  beginSocialSignIn: (provider: SocialProvider) => boolean;
  finishSocialSignIn: () => void;
};

/** Shared UI progress only. Session data remains in Better Auth/TanStack Query. */
export const useAuthUiStore = create<AuthUiState>()((set, get) => ({
  passwordSaved: false,
  setPasswordSaved: (passwordSaved) => set({ passwordSaved }),
  pendingSocialProvider: null,
  beginSocialSignIn: (provider) => {
    // Guard synchronously: another button can fire before React renders disabled.
    if (get().pendingSocialProvider !== null) return false;
    set({ pendingSocialProvider: provider });
    return true;
  },
  finishSocialSignIn: () => set({ pendingSocialProvider: null }),
}));
